import { render, staticRenderFns } from "./AddExistingAsAdmin.vue?vue&type=template&id=2167d8bd&scoped=true"
import script from "./AddExistingAsAdmin.vue?vue&type=script&lang=ts"
export * from "./AddExistingAsAdmin.vue?vue&type=script&lang=ts"
import style0 from "./AddExistingAsAdmin.vue?vue&type=style&index=0&id=2167d8bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2167d8bd",
  null
  
)

export default component.exports